"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullName = void 0;
/**
 * Get full name of a member
 *
 * @public
 * @param {firstName?: FirstName; lastName?: LastName} obj - The object containing the first and last name
 *
 * @returns {string | null}
 *
 * @example
 * ```ts
 * const result = getFullName({firstName: 'John', lastName: 'Doe'});
 * console.log(result);
 * // => 'John Doe'
 * ```
 */
function getFullName({ firstName = '', lastName = '', }) {
    return !firstName && !lastName ? null : `${firstName} ${lastName}`.trim();
}
exports.getFullName = getFullName;
//# sourceMappingURL=get-full-name.js.map